const countdownElement = document.querySelector('.countdown');
const minutesEl = document.querySelector('.minutes');
const secondsEl = document.querySelector('.seconds');
const timeString = countdownElement.dataset.time;
const initialSeconds = parseTime(timeString);
let cookieValue = parseInt(getCookie("custom_value"));
let totalSeconds;

if (!cookieValue || cookieValue >= initialSeconds) {
  totalSeconds = initialSeconds;
} else {
  totalSeconds = cookieValue;
}

setCookie("custom_value", totalSeconds, 365);

function parseTime(time) {
  const [minutes, seconds] = time.split(':').map(Number);
  return minutes * 60 + seconds;
}

function updateCountdown() {
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;

  minutesEl.textContent = String(minutes).padStart(2, '0');
  secondsEl.textContent = String(seconds).padStart(2, '0');

  if (totalSeconds > 0) {
    totalSeconds--;
  } else {
    totalSeconds = initialSeconds;
  }

  setCookie("custom_value", totalSeconds, 365);
}

function setCookie(name, value, days) {
  const d = new Date();
  d.setTime(d.getTime() + (days*24*60*60*1000));
  document.cookie = `${name}=${value};expires=${d.toUTCString()};path=/`;
}

function getCookie(name) {
  const cname = name + "=";
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(';');
  
  for(let i = 0; i < ca.length; i++) {
    let c = ca[i].trim();
    if (c.indexOf(cname) === 0) {
      return c.substring(cname.length, c.length);
    }
  }
  return null;
}

updateCountdown();
setInterval(updateCountdown, 1000);